import { alpha, styled, SxProps, TableCell, tableCellClasses, Theme } from '@mui/material';

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
    color: theme.palette.primary.dark,
    fontWeight: 700,
  },
  [`&.${tableCellClasses.body}`]: {
    opacity: 0.9,
  },
}));

const styles: SxProps<Theme> = {};

export default styles;
